import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Container } from '@angular/compiler/src/i18n/i18n_ast';
import { Injectable } from '@angular/core';
import { NewContainer } from '@classes/container/container';
import { Pagination } from '@classes/pagination/pagination';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { PaginationRespContainer } from '@classes/pagination/paginationResp';
import { environment } from '@environments/environment';
import { Subject, BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContainersService {

  lastQuery = null;
  containerListChanged = new Subject<Container[]>();
  eventsListSubject = new BehaviorSubject<PaginationRespContainer>(null);

  paginationRecordsSubject = new BehaviorSubject<Pagination>(null);
  private containerList: Container[] = [];

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */


  getContainers(request: PaginationRequest) {
    let httpParams = new HttpParams();

    if (request.query) {
      const filters = request.query;
      const filtersQuery = [];


      if (filters.createdOnFrom && filters.createdOnTo) {
        filtersQuery.push(`createdOn>=${filters.createdOnFrom},createdOn<=${filters.createdOnTo}`);
      }
      if (filters.startedOnFrom && filters.startedOnTo) {
        filtersQuery.push(`startedOn>=${filters.startedOnFrom},startedOn<=${filters.startedOnTo}`);
      }

      this.lastQuery = request.query;

      httpParams = httpParams.append('filters', filtersQuery.join());



    } else {
      this.lastQuery = null;
    }

    if (request.pageSize && request.includeCount && request.page) {
      httpParams = httpParams
        .append('pageSize', request.pageSize.toString())
        .append('page', request.query !== this.lastQuery ? '1' : request.page.toString());
    }

    if (request.sort) {
      httpParams = httpParams.append('sorts', request.sort);
    }


    this.http.get(`${environment.apiUrl}/containers`, { params: httpParams, observe: 'response', headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` } })
      .subscribe((result: HttpResponse<any[]>) => {
        this.containerList = result.body;

        const eventsList = new PaginationRespContainer(result.body, result.headers.get('x-pagination'));
        this.eventsListSubject.next(eventsList);

      });
  }

  getSingleContainer(id: string): Observable<Container> {
    return this.http.get<Container>(`${environment.apiUrl}/containers/${id}`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` }
    });
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */


  addNewContainer(container: NewContainer) {
    return this.http.post<NewContainer>(`${environment.apiUrl}/containers`, container);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */


  /* -------------------------------------------------------------------------- */
  /*                                   DELETE                                   */
  /* -------------------------------------------------------------------------- */

  deleteContainer(id: string) {
    return this.http.delete(`${environment.apiUrl}/containers/${id}`);
  }
}
